import Axios from '@/plugins/Axios';

import {
  CourierList,
  Subscription,
  SubscriptionClaimID,
  SubscriptionInvoice,
  UpdateDelivery,
  UpdateSubscription,
  ValidateInsuranceCeiling,
  ValidateInsuranceCeilingResponse,
  ValidatePromo,
  ValidatePromoRes,
} from '@/types';

const endpoint = '/subscription';

const subscriptionApi = {
  getSubscriptionDetail: (id: string, isPatrep: string | null) => {
    const query = isPatrep ? `?is_patrep=${isPatrep}` : '';
    return Axios({ version: '/v2' }).get<Subscription>(
      `${endpoint}/${id}${query}`
    );
  },

  updateSubscription: (id: string, data: UpdateSubscription) => {
    return Axios({ version: '/v2' }).put(`${endpoint}/${id}`, data);
  },

  validatePromo: (id: string, data: ValidatePromo) => {
    return Axios().post<ValidatePromoRes>(`${endpoint}/${id}/promo`, data);
  },

  calculatePromo: (id: string, data: ValidatePromo) => {
    return Axios().post<ValidatePromoRes>(
      `${endpoint}/${id}/promo-calculation`,
      data
    );
  },

  removePromo: (id: string | number) => {
    return Axios().delete(`${endpoint}/${id}/promo`);
  },

  getCourierList: (addressId: number, id: string) => {
    return Axios({ version: '/v2' }).get<[CourierList]>(
      `${endpoint}/${id}/delivery?address_id=${addressId}`
    );
  },

  updateDelivery: (id: string, data: UpdateDelivery) => {
    return Axios({ version: '/v2' }).put(`${endpoint}/${id}/delivery`, data);
  },

  getSubscriptionInvoice: (id: string) => {
    return Axios({ customCallbackError: { UNKNOWN_ERROR: () => null } }).get<
      SubscriptionInvoice
    >(`${endpoint}/${id}/invoice`);
  },

  validateInsuranceCeiling: (id: string, data: ValidateInsuranceCeiling) => {
    return Axios().post<ValidateInsuranceCeilingResponse>(
      `${endpoint}/${id}/insurance`,
      data
    );
  },

  getSubscriptionClaimID: (id: string) => {
    return Axios({ customCallbackError: { UNKNOWN_ERROR: () => null } }).get<
      SubscriptionClaimID
    >(`${endpoint}/${id}/claim`, {
      timeout: 180000,
    });
  },

  unsubscribe: (id: string) => {
    return Axios().put(`${endpoint}/${id}/reminder`, {
      unsubscribe: 1,
    });
  },

  cancelSubscription: (id: string) => {
    return Axios().put(`${endpoint}/${id}/cancel`);
  },
};

export default subscriptionApi;
